import { render, staticRenderFns } from "./PeriodArticle.vue?vue&type=template&id=3fc1c92a&scoped=true"
import script from "./PeriodArticle.vue?vue&type=script&lang=js"
export * from "./PeriodArticle.vue?vue&type=script&lang=js"
import style0 from "./PeriodArticle.vue?vue&type=style&index=0&id=3fc1c92a&prod&lang=less&scoped=true"
import style1 from "./PeriodArticle.vue?vue&type=style&index=1&id=3fc1c92a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1c92a",
  null
  
)

export default component.exports